"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/margin/selectors");
var _futuresSelectors = require("../../redux/futures/selectors/futuresSelectors");
var _InstrumentPositionsTabs = _interopRequireDefault(require("../InstrumentPositionsTabs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    isMarginActive: (0, _selectors.isMarginActiveSelector)(state),
    isFuturesActive: (0, _futuresSelectors.isFuturesActiveSelector)(state)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_InstrumentPositionsTabs["default"]);